import { SelectionChangedEvent } from "ag-grid-community";
import { ParticipationRateEntity } from "domain/entity/ParticipationRate/ParticipationRateEntity";
import _ from "lodash";
import { INITIAL_PARTICIPATION_RATE_COL_DEF, transferRowData } from "presentation/constant/ParticipationRate/ParticipationRateMaintenanceColumnDefinition";
import { ParticipationRateMaintenanceConstant } from "presentation/constant/ParticipationRate/ParticipationRateMaintenanceConstant";
import { useParticipationRateMaintenanceVM } from "presentation/hook/ParticipationRate/useParticipationRateMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useParticipationRateMaintenanceTracked } from "presentation/store/ParticipationRate/ParticipationRateMaintenanceProvider";
import RightClickMenuWithMoveAfter from "presentation/view/components/NbisRightClickMenu/RightClickMenuWithMoveAfter";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { createRef, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";


const ParticipationRateTablePanel: React.FC = () => {
    const [participationRateState] = useParticipationRateMaintenanceTracked();
    const participationRateVM = useParticipationRateMaintenanceVM();
    const gridRef: any = useRef(null);
    const rightClickRef: any = createRef();
    const { selectedRows, searchCriteria } = participationRateState;
    const [anainfoState] = useANAInfoTracked();
    const { allowUpdate } = anainfoState;
    const messageBarVM = useMessageBarVM();
    const [allRows, setAllRows] = useState<ParticipationRateEntity[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [initialAllRows, setInitialAllRows] = useState<boolean>(true);
    const [showMoveCursor, setShowMoveCursor] = useState<boolean>(false);
    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);

    const getAllRows = useCallback(() => {
        return allRows;
    }, [allRows]);

    const getSelectedRows = useCallback(() => {
        return selectedRows;
    }, [selectedRows]);

    // const getShowMoveCursor = useCallback(() => {
    //     return showMoveCursor;
    // }, [showMoveCursor]);

    // useEffect(() => {
    //     if (!participationRateState.selectedRows || participationRateState.selectedRows.length <= 0) {
    //         if (!onTableSelectionClicked) {
    //             gridRef.current?.gridRef.current.api?.deselectAll();
    //         }
    //     }
    //     changeCursor("participation-rate-table", getShowMoveCursor());
    // })

    // useEffect(() => {
    //     if (!onTableSelectionClicked) return;
    //     gridRef.current?.gridRef.current.api?.deselectAll();
    //     changeCursor("participation-rate-table", getShowMoveCursor());
    // }, [getShowMoveCursor, onTableSelectionClicked])

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        // setOnTableSelectionClicked(true);
        participationRateVM.updateSelectedRows(selectedRows);
    }, [participationRateVM])

    const handleRowDoubleClick = useCallback((entity: ParticipationRateEntity) => {
        participationRateVM.onEdit(entity);
    }, [participationRateVM])

    const onSearchClick = useCallback(() => {
        participationRateVM.onSearchClick();
    }, [participationRateVM])

    useEffect(() => {
        const handleRightClickMenu = (event: any) => {
            if (_.isEmpty(participationRateState.selectedRows) || !allowUpdate) {
                return;
            }
            event.preventDefault();
            rightClickRef.current.show(event);
        };
        document.getElementById('myDiv')?.addEventListener("contextmenu", handleRightClickMenu);

        return () => {
            document.getElementById('myDiv')?.removeEventListener("contextmenu", handleRightClickMenu);
        };
    }, [messageBarVM, rightClickRef, allowUpdate, participationRateState.selectedRows])

    const onRefreshRow = useCallback((newAllRows: any[]) => {
        setAllRows(newAllRows);
        participationRateVM.updateSelectedRows([]);
        setShowMoveCursor(true);
    }, [participationRateVM]);

    const onMoveCancel = useCallback(() => {
        setInitialAllRows(true);
        setAllRows(participationRateState.tableData);
        participationRateVM.updateSelectedRows([]);
        setShowMoveCursor(false);
    }, [participationRateState.tableData, participationRateVM]);

    const onSaveMove = useCallback(async (newAllRows: any[]) => {
        if (_.isEmpty(newAllRows)) return;

        setIsLoading(true);

        participationRateVM.onApply(newAllRows).then((res) => {
            if (!res || !res.success) {
                messageBarVM.showError('Move failed.');
                setInitialAllRows(true);
                setIsLoading(false);

                participationRateVM.updateSelectedRows([]);
                setShowMoveCursor(false);
            } else {
                participationRateVM.onSearch(false, searchCriteria).then((data) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    participationRateVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                }).catch((e) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    participationRateVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                })
            }
        })
    }, [participationRateVM, messageBarVM, searchCriteria]);

    const memoBtns = useMemo(() => {

        const hdrBtns = [];
        hdrBtns.push({
            id: 'onSearchClick',
            icon: 'Icon-search',
            title: 'Search',
            disable: false
        })

        return hdrBtns
    }, [])

    const memoTariffCodeTable = useMemo(() => {
        return (
            <>
                {(allowUpdate) && <RightClickMenuWithMoveAfter disabled={_.isEmpty(getSelectedRows())}
                    rightClickRef={rightClickRef} selectedRows={getSelectedRows()} allRows={getAllRows()}
                    onSaveMove={onSaveMove} onCancel={onMoveCancel} onRefreshRow={onRefreshRow}
                    showConfirmMove={showMoveCursor} priorityName="priority" isMasterFsp={true} />}
                <div id="myDiv">
                    <NbisTable
                        id='participation-rate-table'
                        headerLabel={ParticipationRateMaintenanceConstant.TITLE}
                        isNewColumnSetting={true}
                        columns={INITIAL_PARTICIPATION_RATE_COL_DEF?.slice()}
                        data={transferRowData(allRows) ?? []}
                        showPaginator={false}
                        editable={false}
                        headerActionButtons={memoBtns}
                        onSearchClick={onSearchClick}
                        showAddIcon={false}
                        showDeleteButton={false}
                        showReloadIcon={false}
                        isScrollHighlighted={true}
                        selectionMode={false}
                        isRowHighligted={true}
                        rowSelection={showMoveCursor ? "single" : "multiple"}
                        // onBodyScroll={(e: any) => changeCursor("participation-rate-table", getShowMoveCursor())}
                        handleSelectionChanged={handleSelectionChange}
                        onRowDoubleClick={(e: any, entity: ParticipationRateEntity) => handleRowDoubleClick(entity)}
                        gridHeight="customHeight"
                        customHeight="calc(100vh - 75px)"
                        ref={gridRef}
                        showCutCursor={showMoveCursor}
                    />
                </div>
            </>
        );
    }, [allowUpdate, getSelectedRows, rightClickRef, getAllRows, onSaveMove, onMoveCancel, onRefreshRow, showMoveCursor, allRows, memoBtns, onSearchClick, handleSelectionChange, handleRowDoubleClick])

    useEffect(() => {
        if (initialAllRows) {
            if (participationRateState.tableData && !_.isEmpty(participationRateState.tableData)) {
                setAllRows(participationRateState.tableData.map((masterFSPEntity, index) => ({
                    ...masterFSPEntity,
                    index: index ?? 0
                })));
            } else {
                setAllRows([]);
            }
            setInitialAllRows(false);
            participationRateState.isShowSearchClick && participationRateVM.onSearchClickCheck();
        }
    }, [initialAllRows, participationRateState.isShowSearchClick, participationRateState.tableData, participationRateVM]);

    useEffect(() => {
        participationRateState.isShowSearchClick && setInitialAllRows(true);
    }, [participationRateState.isShowSearchClick]);

    return <><TableWrapper>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        {memoTariffCodeTable}
        {participationRateState.forceRefresh && <></>}
    </TableWrapper>
    </>;
}

export default memo(ParticipationRateTablePanel);
